
import { useStore } from "@/store";
import { defineComponent } from "vue";
import IconVue from "./Icon.vue";
import { marked } from "marked";

export default defineComponent({
  components: {
    IconVue,
  },
  computed: {
    experiences() {
      return useStore().state.work;
    },
  },
  methods: {
    dateFromString(date: string | null) {
      if (date === null) {
        return "Present";
      }
      const [month, year] = date.split("-");
      return (
        new Date(new Date().getFullYear(), +month - 1).toLocaleString(
          "default",
          { month: "long" }
        ) +
        " " +
        year
      );
    },
    markdown(raw: string) {
      return marked(raw);
    },
  },
});
